import { EducationPlan } from "../../../generated/graphql";

export type CourseItemType = Pick<EducationPlan, "id" | "name" | "courseIsAvailable">;

export enum CourseActionType {
    Add = "add",
    Remove = "remove",
};
